<template>
    <div style="height:100%">
        <div class="Main">
            <div class="topMain">
                <div slot="header" class="clearfix">
                    <span>菜单管理</span>
                    <el-button v-if="multipleSelection.length == 0" style="float: right;" type="primary" @click="addBtn">创建
                    </el-button>
                    <div style="float: right;" v-if="multipleSelection.length != 0">
                        <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
                            个</span>
                        <el-dropdown trigger="click" @command="operationBtn">
                            <span class="el-dropdown-link">
                                操作<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
            </div>
            <div class="coreMain">
                <div>
                    <el-input class="input-with-select" placeholder="搜索菜单" v-model="search" @keyup.enter.native="searchBtn">
                    </el-input>
                    <el-button @click="searchBtn" icon="el-icon-search" type="primary"></el-button>
                    <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
                </div>
                <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
                    <el-table-column prop="menuName" label="菜单名称"></el-table-column>
                    <el-table-column prop="menuCode" label="菜单code"></el-table-column>
                    <el-table-column prop="permissionName" label="按钮名称">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.permissionName" :type="
              scope.row.permissionName=='新增'?''
              :scope.row.permissionName=='列表'?'success'
              :scope.row.permissionName=='查看'?'info'
              :scope.row.permissionName=='修改'?'warning'
              :scope.row.permissionName=='删除'?'danger'
              :''
              "> {{scope.row.permissionName}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="permissionCode" label="按钮code">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.permissionCode" color='#fff'> {{scope.row.permissionCode}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <!-- <el-button
                size="mini"
                type="text"
                @click="editBtn(scope.row.id)">编辑</el-button> -->
                            <el-button size="mini" type="text" @click="delBtn(scope.row.id)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 创建菜单-->
        <el-dialog title="新增菜单" :visible.sync="dialogFormVisible">
            <el-form :model="addForm" status-icon ref="addForm" :rules="addFormRules" :label-width="formLabelWidth">
                <el-form-item label="创建类型" :label-width="formLabelWidth">
                    <el-radio-group v-model="addType">
                        <el-radio label="menu">菜单</el-radio>
                        <el-radio label="permission">按钮</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="addType=='menu'" label="菜单名称：" prop="menuName">
                    <el-input style="width:70%" v-model="addForm.menuName" autocomplete="off" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item v-if="addType=='menu'" label="菜单标识：" prop="menuCode">
                    <el-input style="width:70%" v-model="addForm.menuCode" autocomplete="off" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item v-if="addType=='menu'" label="排序：" prop="orderNum">
                    <el-input style="width:70%" v-model="addForm.orderNum" autocomplete="off" maxlength="11"></el-input>
                </el-form-item>
                <el-form-item v-if="addType=='permission'" label="按钮名称：" prop="permissionName">
                    <el-input style="width:70%" v-model="addForm.permissionName" auto-complete="off" maxlength="100"></el-input>
                </el-form-item>
                <el-form-item v-if="addType=='permission'" label="按钮code：" prop="permissionCode">
                    <el-input style="width:70%" v-model="addForm.permissionCode" auto-complete="off" maxlength="32"></el-input>
                </el-form-item>
                <el-form-item label="上级菜单：" prop="parentName">
                    <!-- <el-select v-model="addForm.parentName" placeholder="请选择菜单名称" @click="getMenu">
                        <el-option v-for="item in menuTree" :key="item.id" :label="item.menuName" :value="item.id">
                        </el-option>
                    </el-select> -->
                    <el-input style='width:70%' disabled v-model='addForm.parentName' placeholder="菜单名称" @click.native="getMenu" auto-complete="off"></el-input>
                    <el-button type="primary" @click="getMenu">选择上级菜单</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="setUp('addForm')">确 定</el-button>
            </div>
            <el-dialog title="选择上级菜单" append-to-body :visible.sync="dialogMenuVisible">
                <el-tree style='padding-left: 10%' :data="menuTree" show-checkbox default-expand-all node-key="id" check-strictly ref="menuTree" highlight-current :props="defaultProps">
                </el-tree>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="selectMenu">确定</el-button>
                    <el-button @click="dialogMenuVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </el-dialog>
    </div>
</template>
<script>
import API from "../../api/api";
import dayjs from "dayjs";
export default {

    data() {
        return {
            total: 0,
            pageSize: 10,
            currentPage: 1,
            loading: false, //加载条
            search: "", //搜索
            dialogFormVisible: false,
            dialogMenuVisible: false,
            addForm: {
                menuName: '',
                menuCode: '',
                orderNum: '',
                permissionName: '',
                permissionCode: '',
                parentName: '',
            },
            addType: 'menu',
            /*新增菜单的菜单树状列表*/
            menuTree: [],
            defaultProps: {
                children: "children",
                label: "menuName"
            },
            addFormRules: {
                menuName: [{
                    required: true,
                    message: "请输入菜单名称",
                    trigger: "blur"
                },],
                menuCode: [{
                    required: true,
                    message: "请输入菜单标识",
                    trigger: "blur"
                },],
                permissionName: [{
                    required: true,
                    message: "请输入按钮名称",
                    trigger: "blur"
                },],
                permissionCode: [{
                    required: true,
                    message: "请输入按钮标识",
                    trigger: "blur"
                },],
            },
            formLabelWidth: "180px",
            tableData: [],
            multipleSelection: []
        };
    },
    created() { },
    methods: {
        //初始化时间
        changeDate(time) {
            if (time != null) {
                return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
            }
            return "";
        },
        //获取列表数据
        getPage() {
            let para = {
                pageSize: this.pageSize,
                currentPage: this.currentPage,
                account: this.search
            };
            let _this = this
            this.loading = true; /*显示加载条*/
            API.sysMenuPermissionList(para)
                .then(res => {
                    if (res.code == 1) {
                        _this.tableData = res.data;
                        _this.total = res.data.total;
                    } else {
                        _this.$message.error(res.msg);
                    }
                    _this.loading = false; /*显示加载条*/
                })
        },

        //搜索功能
        searchBtn() {
            (this.status = ""), //下拉选项为空
                this.getPage();
        },
        //清除搜索条件
        reset() {
            this.search = "";
            this.getPage();
        },
        //选择的数组
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        //批量操作-删除
        operationBtn(val) {
            if (val.type == "del") {
                let arr = [];
                val.para.forEach(element => {
                    arr.push(element.id);
                });
                let str = arr.join(",");
                this.delBtn(str);
            }
        },
        //单独删除功能
        command(val) {
            if (val.type == "del") {
                let str = val.id;
                this.delBtn(str);
            }
            if (val.type == "edit") {
                this.editdialogFormVisible = true;
                API.userView(val.id)
                    .then(res => {
                        if (res.code == 1) {
                            this.editForm = res.data;
                        } else {
                            this.$message.error(res.msg);
                        }
                    })
            }
        },

        //删除功能 单独批量公用
        delBtn(delID) {
            let para = {
                ids: delID
            };
            this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() => {
                    API.delSysMenuPermission(para).then(res => {
                        if (res.code == 1) {
                            if (res.data.length == 0) {
                                this.$message.success("删除成功");
                                this.getPage();
                            } else {
                                this.$message.error(res.data + '含有子菜单，删除失败');
                            }
                        } else {
                            this.$message.error("删除失败");
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除"
                    });
                });
        },
        //编辑
        editBtn() {

        },
        // //弹出创建页
        addBtn() {
            this.dialogFormVisible = true;
            this.$nextTick(() => {
                this.$refs.addForm.resetFields()
            })
        },
        //弹出上一级菜单
        getMenu() {
            console.log(11111)
            this.dialogMenuVisible = true
            API.sysMenuPermissionList().then(res => {
                if (res.code == 1) {
                    this.menuTree = res.data
                    let _this = this
                    for (let i = 0; i < _this.menuTree.length; i++) {
                        if (_this.menuTree[i].permissionCode != null && _this.menuTree[i].permissionCode != '') {
                            _this.menuTree[i].menuName = _this.menuTree[i].permissionName
                        }
                        if (_this.menuTree[i].children) {
                            for (let j = 0; j < _this.menuTree[i].children.length; j++) {
                                if (_this.menuTree[i].children[j].permissionCode != null && _this.menuTree[i].children[j]
                                    .permissionCode != '') {
                                    _this.menuTree[i].children[j].menuName = _this.menuTree[i].children[j].permissionName
                                }
                                if (_this.menuTree[i].children[j].children) {
                                    for (let k = 0; k < _this.menuTree[i].children[j].children.length; k++) {
                                        if (_this.menuTree[i].children[j].children[k].permissionCode != null && _this.menuTree[i]
                                            .children[j].children[k].permissionCode != '') {
                                            _this.menuTree[i].children[j].children[k].menuName = _this.menuTree[i].children[j].children[
                                                k].permissionName
                                        }
                                        if (_this.menuTree[i].children[j].children[k].children) {
                                            for (let p = 0; p < _this.menuTree[i].children[j].children[k].children.length; p++) {
                                                if (_this.menuTree[i].children[j].children[k].children[p].permissionCode != null && _this
                                                    .menuTree[i].children[j].children[k].children[p].permissionCode != '') {
                                                    _this.menuTree[i].children[j].children[k].children[p].menuName = _this.menuTree[i]
                                                        .children[j].children[k].children[p].permissionName
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            })
        },
        //选择完上一级菜单
        selectMenu() {
            let keys = this.$refs.menuTree.getCheckedKeys();
            let menuId = keys[keys.length - 1];
            let notes = this.$refs.menuTree.getCheckedNodes();
            this.addForm.parentId = keys[keys.length - 1];
            for (var i = 0; i < notes.length; i++) {
                if (notes[i].id == menuId) {
                    this.addForm.parentName = notes[i].menuName;
                    this.addForm.parentId = notes[i].id;
                    this.addForm.parentMenuCode = notes[i].menuCode;
                }
            }
            this.dialogMenuVisible = false;
        },
        //新增菜单确认按钮
        setUp(formName) {
            let _this = this;
            let _API = API;
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.addType == 'permission') {
                        this.addForm.menuCode = this.addForm.parentMenuCode
                        this.addForm.menuName = this.addForm.parentName
                    }
                    _API.addSysMenuPermission(_this.addForm).then(res => {
                        if (res.code == 1) {
                            _this.$message({
                                message: "创建菜单/按钮成功",
                                type: "success"
                            });
                            this.dialogFormVisible = false;
                            this.getPage();
                        } else {
                            _this.$message({
                                message: res.msg,
                                type: "error"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        //分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.getPage();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getPage();
        }
    },
    mounted() {
        this.getPage();
        // this.getMenu()
    }
};

</script>



// WEBPACK FOOTER //
// src/views/platform/menuManagement.vue